import { _ as __vite_glob_0_0, a as __vite_glob_0_2, b as __vite_glob_0_3, c as __vite_glob_0_7, d as __vite_glob_0_8, e as __vite_glob_0_9 } from "../../../../chunks/riley.js";
import { _ as __vite_glob_0_6 } from "../../../../chunks/icon.js";
import { e as error } from "../../../../chunks/index2.js";
import * as path from "node:path";
import { c as read_implementation, b as base, m as manifest } from "../../../../chunks/server.js";
import { a as b64_decode } from "../../../../chunks/utils.js";
const formsPinkishBlur = "/_app/immutable/assets/forms-pinkish-blur.D7ku142L.png";
const __vite_glob_0_1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formsPinkishBlur
}, Symbol.toStringTag, { value: "Module" }));
const icon$1 = "/_app/immutable/assets/icon.gHcCChSy.ico";
const __vite_glob_0_4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: icon$1
}, Symbol.toStringTag, { value: "Module" }));
const icon = "/_app/immutable/assets/icon.B7pyAb_y.png";
const __vite_glob_0_5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: icon
}, Symbol.toStringTag, { value: "Module" }));
function read(asset) {
  ;
  if (!read_implementation) {
    throw new Error(
      "No `read` implementation was provided. Please ensure that your adapter is up to date and supports this feature"
    );
  }
  const match = /^data:([^;,]+)?(;base64)?,/.exec(asset);
  if (match) {
    const type = match[1] ?? "application/octet-stream";
    const data = asset.slice(match[0].length);
    if (match[2] !== void 0) {
      const decoded2 = b64_decode(data);
      return new Response(decoded2, {
        headers: {
          "Content-Length": decoded2.byteLength.toString(),
          "Content-Type": type
        }
      });
    }
    const decoded = decodeURIComponent(data);
    return new Response(decoded, {
      headers: {
        "Content-Length": decoded.length.toString(),
        "Content-Type": type
      }
    });
  }
  const file = decodeURIComponent(
    asset.slice(base.length + 1)
  );
  if (file in manifest._.server_assets) {
    const length = manifest._.server_assets[file];
    const type = manifest.mimeTypes[file.slice(file.lastIndexOf("."))];
    return new Response(read_implementation(file), {
      headers: {
        "Content-Length": "" + length,
        "Content-Type": type
      }
    });
  }
  throw new Error(`Asset does not exist: ${file}`);
}
const modules = /* @__PURE__ */ Object.assign({
  "/src/lib/client/assets/alex.png": __vite_glob_0_0,
  "/src/lib/client/assets/forms-pinkish-blur.png": __vite_glob_0_1,
  "/src/lib/client/assets/glimmr-product-diagram.png": __vite_glob_0_2,
  "/src/lib/client/assets/happy-customer.png": __vite_glob_0_3,
  "/src/lib/client/assets/icon.ico": __vite_glob_0_4,
  "/src/lib/client/assets/icon.png": __vite_glob_0_5,
  "/src/lib/client/assets/icon.svg": __vite_glob_0_6,
  "/src/lib/client/assets/jordan.png": __vite_glob_0_7,
  "/src/lib/client/assets/mia.png": __vite_glob_0_8,
  "/src/lib/client/assets/riley.png": __vite_glob_0_9
});
const GET = async ({ params }) => {
  const filename = params.filename;
  const module = Object.keys(modules).find(
    (modulePath) => path.basename(modulePath) === filename
  );
  if (!module) {
    error(404, {
      message: "File not found"
    });
  }
  return read(module);
};
export {
  GET
};
